import { render } from "./Footer.vue?vue&type=template&id=02846d33&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=02846d33&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/aclu-sdic-ice-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02846d33"]])

export default __exports__